import { To, useLocation, useNavigate } from 'react-router-dom-v5-compat';

import { Button, Icon, keyframes } from '@project44/manifest-ds';

interface ICellNavigate {
  isDisabled: boolean;
  text: string;
  to: To;
}

const fadeInLeft = keyframes({
  from: {
    opacity: 0,
    transform: 'translate3d(-100%, 0, 0)',
  },
  to: {
    opacity: 1,
    transform: 'translate3d(0, 0, 0)',
  },
});

const style = {
  '#nav-btn-icon': {
    display: 'none',
    opacity: 0,
    visibility: 'hidden',
  },
  '&:hover': {
    color: '$palette-indigo-900',
    backgroundColor: '$palette-indigo-50',
    borderColor: 'transparent',
    '#nav-btn-icon': {
      animation: `${fadeInLeft} 250ms ease both`,
      display: 'block',
      visibility: 'visible',
    },
  },
  '&:disabled': {
    backgroundColor: '$palette-grey-100',
    borderColor: 'transparent',
  },
};

function CellNavigate({ text, to, isDisabled }: ICellNavigate) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    navigate(to, { state: { prevSearch: location.search } });
  };

  return (
    <Button
      data-testid="navigate-button"
      onPress={handleClick}
      isDisabled={isDisabled}
      children={text}
      css={{
        ...style,
        borderRadius: '$full',
        fontSize: '$x-small',
        border: '1px solid $palette-grey-300',
        backgroundColor: '$palette-white',
        boxShadow: 'none',
        color: '$palette-grey-700',
        height: 'auto',
        padding: '$x-small $medium',
      }}
      endIcon={
        <Icon
          id="nav-btn-icon"
          icon="trending_flat"
          css={{ fontSize: '$medium' }}
        />
      }
    />
  );
}

export default CellNavigate;
